import { Box, FormControl, MenuItem, Select } from "@mui/material";
import { useCarouselContext } from "../../context/CarouselContext";

const IMAGE_TYPE_LABELS: Record<string, string> = {
    img_ext: "Exterior",
    img_man: "Manual",
    img_int: "Interior",
    img_crop: "Cropped",
    img_pano: "Panoramic",
    img_uc: "Undercarriage",
    img_featured: "Featured",
    img_brand_exterior: "Branded Exterior",
    img_brand_featured: "Branded Featured",
    img_bgr: "Background Replaced",
    img_bgr_exterior: "BGR Exterior",
    img_bgr_pano: "BGR Panoramic",
    img_bgr_manual: "BGR Manual",
    img_bgblur: "Background Blur",
    img_bgr_blur: "Background Blur",
};

export default function ImageTypeSelect() {
      const {
        selectedType,
        uniqueImageTypes,
        sortedImages,
        setSelectedType,
      } = useCarouselContext();

    if (uniqueImageTypes.length < 2) return <></>

    return (
            <FormControl size="small" sx={{ minWidth: 120 }}>
                <Select
                    data-cy="carousel-image-type-select"
                    value={selectedType}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => setSelectedType(e.target.value)}
                    sx={{
                        color: "#fff",
                        fontSize: "0.75rem",
                        padding: "0 6px",
                        background: "rgba(0, 0, 0, 0.7)",
                        borderRadius: "5px"
                    }}
                >
                    <MenuItem value="all">All Images</MenuItem>
                    {uniqueImageTypes.map((type) => (
                        <MenuItem key={type} value={type ?? ""}>
                            {IMAGE_TYPE_LABELS[type ?? ""] || type} (
                            {sortedImages.filter((img) => img.imageType === type).length})
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
    );
}
